import { createSelector } from 'reselect'
import { ReportDataType, ReportRow } from '../../../context/reports/types'
import { pagesSelector } from '../../selectors'
import { periodGroupLabel } from '../../../context/fiscalYears/utils'
import { PeriodGroup } from '../../../../types/periodGroup/PeriodGroup'
import { MultiDashboard } from '../../../../features/dashboards'
import { parseDate } from '../../../../config/dayjsConfig'

export const multiPurposeDashboardPageSelector = createSelector(pagesSelector, pages => pages.multiPurposeDashboard)

const getKeyFigureValue = (keyFigure: ReportRow, periodGroupId: number): number | undefined => {
  if (!keyFigure.actuals) return undefined
  const balance = keyFigure.actuals.find(b => b.groupId === periodGroupId)
  return balance?.value
}

const getTableRowValue = (keyFigure: ReportRow, { startDate, endDate }: MultiDashboard) => {
  const parsedStartDate = parseDate(startDate)
  const parsedEndDate = parseDate(endDate)

  const year = parsedStartDate?.year() || 0
  const value = getKeyFigureValue(keyFigure, year)
  const historyValue = getKeyFigureValue(keyFigure, -year)

  return {
    currentValue: {
      label: year,
      type: keyFigure.type,
      value
    },
    historyValue: {
      label: periodGroupLabel(
        {
          startDate: parsedStartDate?.subtract(12, 'M').format('YYYY-MM-DD') || '',
          endDate: parsedEndDate?.subtract(12, 'M').format('YYYY-MM-DD') || ''
        } as unknown as PeriodGroup,
        ReportDataType.actuals
      ),
      type: keyFigure.type,
      value: historyValue
    }
  }
}

export const getTableRows = (report: ReportRow[], dashboard: MultiDashboard) => {
  return report?.reduce((rows, keyFigure) => {
    return { ...rows, [keyFigure.id]: getTableRowValue(keyFigure, dashboard) }
  }, {})
}
